module.exports = __webpack_public_path__ + "img/ico_bell--wh.3b0f6c72.svg";